"use strict";
var Observable_1 = require('../../Observable');
var concat_1 = require('../../observable/concat');
Observable_1.Observable.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/rxjs/add/observable/concat.js
// module id = ../../../../rxjs/add/observable/concat.js
// module chunks = 4